import type { GameComponentProps } from '../core/types';
import { FixtureGame } from '../fixture/FixtureGame';
import { MiniCrosswordGame } from './MiniCrosswordGame';

export function MiniCrosswordEntry(props: GameComponentProps) {
  if (props.puzzle.generatorVersion < 2) return <FixtureGame {...props} />;
  if (
    props.puzzle.generatorVersion === 2 &&
    props.puzzle.payload &&
    typeof props.puzzle.payload === 'object'
  ) {
    const legacy = props.puzzle.payload as Record<string, unknown>;
    const clueCount = Array.isArray(legacy.clues) ? legacy.clues.length : 0;
    return (
      <MiniCrosswordGame
        {...props}
        puzzle={{
          ...props.puzzle,
          payload: {
            ...legacy,
            layout: 'Legacy Mini Crossword',
            goodClueCount: clueCount,
          },
        }}
      />
    );
  }
  return <MiniCrosswordGame {...props} />;
}
